import { gql } from '@apollo/client'

const QUERY_MERCHANT_ONBOARDING_STATUS = gql`
  query merchantOnboardingStatus($id: uuid!) {
    merchantOnboardingStatus(merchantId: $id) {
      hasCard
      hasLogos
      hasDiscount
      hasKeyImages
      hasLoyaltyCard
      hasModifier
      hasProduct
      hasStore
      hasStripeSetup
    }
  }
`

const QUERY_MERCHANT_HAS_STRIPE_SUBSCRIPTION = gql`
  query checkMerchantHasStripeSubscription($id: ID) {
    merchantHasStripeSubscription(merchantId: $id)
  }
`

const QUERY_TERMS = gql`
  query getTerms {
    terms(order_by: { inserted_at: desc_nulls_last }) {
      terms_and_conditions
      id
      inserted_at
      updated_at
    }
  }
`

const QUERY_SIGNATURE = gql`
  query getSignature($merchantId: uuid!) {
    signatures(
      where: { merchant_id: { _eq: $merchantId } }
      order_by: { inserted_at: desc_nulls_last }
    ) {
      agreed
      terms_id
    }
  }
`

const QUERY_HUBSPOT_ACCESS_TOKEN = gql`
  query hubspotToken($userId: uuid!) {
    getHubspotAccessToken(userId: $userId)
  }
`

export {
  QUERY_TERMS,
  QUERY_SIGNATURE,
  QUERY_MERCHANT_HAS_STRIPE_SUBSCRIPTION,
  QUERY_HUBSPOT_ACCESS_TOKEN,
  QUERY_MERCHANT_ONBOARDING_STATUS
}
